import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  LoyaltyTransaction,
  LoyaltyTransactionQuery,
  LoyaltyTransactionsQueryBuilder,
  QueryLoyaltyTransactionsResponse,
  getLoyaltyTransaction as universalGetLoyaltyTransaction,
  queryLoyaltyTransactions as universalQueryLoyaltyTransactions,
  typedQueryLoyaltyTransactions as universalTypedQueryLoyaltyTransactions,
} from './loyalty-transaction-v1-loyalty-transaction-transactions.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/loyalty' };

export function getLoyaltyTransaction(
  httpClient: HttpClient
): GetLoyaltyTransactionSignature {
  return (loyaltyTransactionId: string) =>
    universalGetLoyaltyTransaction(
      loyaltyTransactionId,
      // @ts-ignore
      { httpClient }
    );
}

interface GetLoyaltyTransactionSignature {
  /**
   * Retrieves a transaction.
   * @param - ID of the loyalty transaction to retrieve.
   * @returns Retrieved loyalty transaction.
   */
  (loyaltyTransactionId: string): Promise<
    NonNullablePaths<
      LoyaltyTransaction,
      | `earnInfo.followedSocialMedia.channel`
      | `earnInfo.appId`
      | `earnInfo.activityType`
      | `earnInfo.limitApplied`
      | `redeemInfo.rewardId`
      | `adjustInfo.appId`
      | `adjustInfo.amountBefore`
      | `adjustInfo.amountAfter`
      | `refundInfo.appId`
      | `expireInfo.amountBefore`
      | `expireInfo.amountAfter`
      | `earnAttemptInfo.appId`
      | `earnAttemptInfo.activityType`
      | `accountId`
      | `amount`
      | `transactionType`
      | `description`
      | `idempotencyKey`,
      4
    >
  >;
}

export function queryLoyaltyTransactions(
  httpClient: HttpClient
): QueryLoyaltyTransactionsSignature {
  return () =>
    universalQueryLoyaltyTransactions(
      // @ts-ignore
      { httpClient }
    );
}

interface QueryLoyaltyTransactionsSignature {
  /**
   * Retrieves a list of loyalty transactions with the specified paging, filtering, and sorting.
   *
   * To learn about working with _Query_ methods, see [API Query Language](https://dev.wix.com/docs/rest/articles/get-started/api-query-language),
   * [Sorting and Paging](https://dev.wix.com/docs/rest/articles/get-started/sorting-and-paging),
   * and [Field Projection](https://dev.wix.com/docs/rest/articles/get-started/field-projection).
   */
  (): LoyaltyTransactionsQueryBuilder;
}

export function typedQueryLoyaltyTransactions(
  httpClient: HttpClient
): TypedQueryLoyaltyTransactionsSignature {
  return (query: LoyaltyTransactionQuery) =>
    universalTypedQueryLoyaltyTransactions(
      query,
      // @ts-ignore
      { httpClient }
    );
}

interface TypedQueryLoyaltyTransactionsSignature {
  /** */
  (query: LoyaltyTransactionQuery): Promise<
    NonNullablePaths<
      QueryLoyaltyTransactionsResponse,
      | `loyaltyTransactions`
      | `loyaltyTransactions.${number}.earnInfo.followedSocialMedia.channel`
      | `loyaltyTransactions.${number}.earnInfo.appId`
      | `loyaltyTransactions.${number}.earnInfo.activityType`
      | `loyaltyTransactions.${number}.earnInfo.limitApplied`
      | `loyaltyTransactions.${number}.redeemInfo.rewardId`
      | `loyaltyTransactions.${number}.adjustInfo.appId`
      | `loyaltyTransactions.${number}.adjustInfo.amountBefore`
      | `loyaltyTransactions.${number}.adjustInfo.amountAfter`
      | `loyaltyTransactions.${number}.refundInfo.appId`
      | `loyaltyTransactions.${number}.expireInfo.amountBefore`
      | `loyaltyTransactions.${number}.expireInfo.amountAfter`
      | `loyaltyTransactions.${number}.earnAttemptInfo.appId`
      | `loyaltyTransactions.${number}.earnAttemptInfo.activityType`
      | `loyaltyTransactions.${number}.accountId`
      | `loyaltyTransactions.${number}.amount`
      | `loyaltyTransactions.${number}.transactionType`
      | `loyaltyTransactions.${number}.description`
      | `loyaltyTransactions.${number}.idempotencyKey`,
      6
    >
  >;
}

export {
  AccountInfo,
  ActionEvent,
  AdjustInfo,
  ApplicationError,
  BulkActionMetadata,
  BulkCreateLoyaltyTransactionsRequest,
  BulkCreateLoyaltyTransactionsResponse,
  BulkLoyaltyTransactionResult,
  CreateLoyaltyTransactionRequest,
  CreateLoyaltyTransactionResponse,
  CursorPaging,
  CursorPagingMetadata,
  CursorQuery,
  CursorQueryPagingMethodOneOf,
  Cursors,
  DomainEvent,
  DomainEventBodyOneOf,
  EarnAttemptInfo,
  EarnInfo,
  EarnInfoActivityDetailsOneOf,
  Empty,
  EntityCreatedEvent,
  EntityDeletedEvent,
  EntityUpdatedEvent,
  ExpireInfo,
  FollowedSocialMedia,
  GetLoyaltyTransactionRequest,
  GetLoyaltyTransactionResponse,
  GetTransactionSumRequest,
  GetTransactionSumResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  ItemMetadata,
  LoyaltyTransaction,
  LoyaltyTransactionQuerySpec,
  LoyaltyTransactionTransactionTypeInfoOneOf,
  LoyaltyTransactionsQueryBuilder,
  LoyaltyTransactionsQueryResult,
  MessageEnvelope,
  QueryLoyaltyTransactionsRequest,
  QueryLoyaltyTransactionsResponse,
  RedeemInfo,
  RefundInfo,
  RestoreInfo,
  RevertTransactionRequest,
  RevertTransactionResponse,
  SortOrder,
  Sorting,
  TransactionType,
  WebhookIdentityType,
  utils,
} from './loyalty-transaction-v1-loyalty-transaction-transactions.universal.js';
